<script lang="ts" setup>
import type { WhiseUnit } from "@/stores/api";
import { string_to_slug } from "@/utils/api-functions";

const props = defineProps<{ estate: WhiseUnit }>();

const formatPrice = (value: number) => {
    let val = (value / 1).toFixed(0).replace(".", ",");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

const getCategoryType = (type?: number) => {
    if (!type) {
        return "";
    }

    const types = {
        1: "Huis",
        2: "Appartement",
        3: "Grond",
        4: "Kantoor",
        5: "Commercieel",
        6: "Industrieel",
        7: "Garage / Parking",
    };

    //@ts-ignore
    return types[type];
};
</script>

<template>
    <a :href="`panden/${estate.id}-${string_to_slug(estate.city)}-${string_to_slug(estate.name)}`" class="flex flex-col" v-if="estate">
        <img v-if="estate.pictures" :data-src="estate.pictures[0].urlLarge" class="lazyload w-full h-[226px] object-cover" />
        <div v-else class="w-full h-[226px] bg-beige-100"></div>
        <div class="p-[13px]">
            <div class="flex flex-wrap flex-row justify-between items-center gap-x-[16px]">
                <div class=" font-medium text-24 leading-[24px] tracking-[0.15px] text-brown-200 max-w-[220px] md:max-w-[450px]">{{ estate.name }}</div>
                <whise-price class="text-[16px] font-medium leading-[24px] tracking-[0.11px]" :display-price="estate.displayPrice" :make-offer="false" :price="estate.price" :purpose="estate.purposeStatus.id" :currency="estate.currency" label-class=""></whise-price>
            </div>
            <div class="font-medium text-14 leading-[24px] tracking-[0.09] mb-[12px]">{{ getCategoryType(estate.category.id) }} - {{ estate.city }}</div>
            <div class="text-15 leading-[24px] tracking-[0.09px] font-light mb-[30px]">
                <div v-if="estate.rooms">
                    <i class="fas fa-bed text-brown-200 w-[30px]"></i>
                    {{ estate.rooms }} slaapkamer<template v-if="estate.rooms > 1">s</template>
                </div>
                <div v-if="estate.bathRooms">
                    <i class="fas fa-bath text-brown-200 w-[30px]"></i>
                    {{ estate.bathRooms }} badkamer<template v-if="estate.bathRooms > 1">s</template>
                </div>
            </div>
        </div>
        <button class="w-full text-white font-bold bg-brown-100 flex items-center justify-center py-[12px] text-center hover:bg-beige-200 transition-colors hover:text-brown-200 mt-auto">Bekijk pand</button>
    </a>
</template>
